<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "host-web-set",
  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
</style>